export default __webpack_public_path__ + "static/photo-diane-dupraz-0a6a29d925c73863faf499cae8bb45e1.webp";